import { Download, ShoppingBag, Sparkles, Palette } from "lucide-react";
import { toast } from "sonner";
import { DIGITAL_TOOLS, SHOP_ITEMS } from "@/data/partnerConfig";
import { usePartner } from "../PartnerContext";
import { Card, PageHeader, Btn, Pill, SectionTitle } from "../ui";

export default function PartnerCommunication() {
  const { partner } = usePartner();
  return (
    <div data-testid="partner-communication">
      <PageHeader
        eyebrow="Image & visibilité"
        title="Communication & Boutique"
        sub="Des supports prêts à l'emploi aux couleurs CozyHome, personnalisés avec les informations de votre entreprise."
      />

      <Card className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-petrol-tint text-petrol"><Palette className="h-5 w-5" /></span>
          <div>
            <p className="text-sm font-bold text-navy">Personnalisation automatique</p>
            <p className="text-xs text-stone-500">Vos supports reprendront : {partner.company} · {partner.phone} · {partner.email} · secteur {partner.sector}.</p>
          </div>
        </div>
        <Pill tone="petrol">Bientôt personnalisable</Pill>
      </Card>

      <div className="mt-6">
        <SectionTitle right={<Pill tone="petrol"><Sparkles className="h-3 w-3" /> Outils digitaux</Pill>}>Outils digitaux</SectionTitle>
        <div data-testid="digital-tools" className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {DIGITAL_TOOLS.map((t) => (
            <Card key={t.id} testid={`digital-${t.id}`} className="flex flex-col p-5">
              <div className="aspect-[16/9] rounded-xl bg-petrol-bg" />
              <h3 className="mt-4 font-semibold text-navy">{t.title}</h3>
              <p className="mt-1 flex-1 text-sm text-stone-500">{t.desc}</p>
              <Btn variant="ghost" className="mt-4 w-full" testid={`digital-download-${t.id}`} onClick={() => toast.info("Le téléchargement des supports personnalisés arrive dans la phase suivante.")}>
                <Download className="h-4 w-4" /> Télécharger
              </Btn>
            </Card>
          ))}
        </div>
      </div>

      <div className="mt-8">
        <SectionTitle right={<Pill tone="copper"><ShoppingBag className="h-3 w-3" /> Boutique</Pill>}>Boutique</SectionTitle>
        <div data-testid="shop-items" className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {SHOP_ITEMS.map((t) => (
            <Card key={t.id} testid={`shop-${t.id}`} className="flex flex-col p-5">
              <div className="aspect-[16/9] rounded-xl bg-[#FBF6F2]" />
              <h3 className="mt-4 font-semibold text-navy">{t.title}</h3>
              <p className="mt-1 flex-1 text-sm text-stone-500">{t.desc}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-stone-400">Tarif sur devis</span>
                <Btn variant="copper" className="px-3.5 py-2 text-xs" testid={`shop-order-${t.id}`} onClick={() => toast.info("La commande en boutique sera connectée dans la phase suivante.")}>
                  Commander
                </Btn>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
